var map = {
	"./en.ts": [
		"./public/locales/en.ts",
		844
	],
	"./id.ts": [
		"./public/locales/id.ts",
		282
	],
	"./ms.ts": [
		"./public/locales/ms.ts",
		325
	],
	"./th.ts": [
		"./public/locales/th.ts",
		741
	],
	"./vi.ts": [
		"./public/locales/vi.ts",
		500
	],
	"./zh.ts": [
		"./public/locales/zh.ts",
		400
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./public/locales lazy recursive ^\\.\\/.*\\.ts$";
module.exports = webpackAsyncContext;